import { store } from "../App";
import { SecureLocalStorage } from "helpers";

export const setTokens = (response) => {
  // get header tokens
  const Authorization = response.headers.get("Authorization");
  const RefreshToken = response.headers.get("RefreshToken");
  // console.log("SETTING TOKENS");
  // console.log(response);
  // console.log(Authorization);
  // console.log(RefreshToken);

  // set header tokens
  if (Authorization != null) {
    SecureLocalStorage.setItem("Authorization", Authorization);
  }
  if (RefreshToken != null) {
    SecureLocalStorage.setItem("RefreshToken", RefreshToken);
  }
  // SecureLocalStorage.setItem("Authorization", Authorization);
  // SecureLocalStorage.setItem("RefreshToken", RefreshToken);

  return response;
};

export const setAuthToken = (response) => {
  const Authorization = response.headers.get("Authorization");

  SecureLocalStorage.setItem("Authorization", Authorization);

  return response;
};

export const unsetTokens = () => {
  SecureLocalStorage.removeItem("Authorization");
  SecureLocalStorage.removeItem("RefreshToken");
};

export const unauthorizedLogout = () => {
  SecureLocalStorage.removeItem("userId");
  SecureLocalStorage.removeItem("persist:root");
  unsetTokens();

  // clear cache and log out
  store.dispatch([
    {
      type: "REMOVE_DEALS",
    },
    {
      type: "REMOVE_REWARDS",
    },
    {
      type: "RESET_DISPLAY",
    },
    {
      type: "RESET_APPLICATIONS",
    },
    {
      type: "UNSET_USER_STATUS",
    },
  ]);
};

export const getTokens = () => {
  const Authorization = SecureLocalStorage.getItem("Authorization");
  const RefreshToken = SecureLocalStorage.getItem("RefreshToken");

  return {
    Authorization,
    RefreshToken,
  };
};

export const refreshAuthToken = () => {
  const userId = SecureLocalStorage.getItem("userId");
  const url = `${__BASE_API_URL__}/refreshToken?userId=${userId}&deviceType=0`;

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      headers: new Headers({
        RefreshToken: getTokens().RefreshToken,
      }),
    })
      .then((res) => {
        // logout user if refreshToken is expired
        if (res.status === 417) {
          unauthorizedLogout();
          resolve();
        }

        return res;
      })
      .then((res) => {
        const Authorization = res.headers.get("Authorization");

        if (res) {
          SecureLocalStorage.setItem("Authorization", Authorization);
          resolve();
        } else {
          reject("Response did not provide auth token");
        }
      })
      .catch(reject);
  });
};
